export const config = {
  urls: {
    DEFAULT_HB_NODE: 'https://push.forward.computer',
    GATEWAY: 'https://ao-search-gateway.goldsky.com',
    CU_DEV: 'https://ao-cu-0.ao-devnet.xyz',
    MU_DEV: 'https://ao-mu-0.ao-devnet.xyz',
    CU_TESTNET: 'https://cu.ao-testnet.xyz',
    MU_TESTNET: 'https://mu.ao-testnet.xyz'
  },
  addresses: {
    SCHEDULER_MAINNET: 'n_XZJhUnmldNFo4dhajoPZWhBXuJk-OcQr5JQ49c4Zo'
  }
}
